module.exports = __webpack_public_path__ + "static/media/ImporterFeature4.ecb33191.svg";